import { Check, X, Link2, MessageCircle, Sparkles } from "lucide-react";
import { formatDateIt, zoneOf } from "../../lib/constants";
import { Group, IconBtn } from "./AdminUI";

const Details = ({ p }) => {
  const ev = p.event_data;
  const isPublic = p.source === "public";
  return (
    <div className="min-w-0">
      <div className="font-display font-bold truncate">{ev.title}</div>
      <div className="text-sm text-wyd-muted">
        {isPublic && ev.venue_name && ev.venue_name !== ev.title ? `${ev.venue_name} · ` : ""}
        {[ev.category, zoneOf(ev)].filter(Boolean).join(" · ")} · {ev.date ? formatDateIt(ev.date) : "data da definire"} · da {p.proposer_name}
      </div>
      {isPublic && (
        <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1 text-xs">
          <a href={ev.source_url} target="_blank" rel="noopener noreferrer" data-testid={`proposal-link-${p.id}`}
            className="flex items-center gap-1 text-wyd-accent hover:underline max-w-[260px] truncate"><Link2 size={12} /> {ev.source_url}</a>
          <span data-testid={`proposal-contact-${p.id}`} className="flex items-center gap-1 text-wyd-accent-soft"><MessageCircle size={12} /> {p.submitter_contact}</span>
          {p.ai_extracted && <span className="flex items-center gap-1 text-wyd-muted"><Sparkles size={12} /> dati letti dal link</span>}
        </div>
      )}
      {ev.description && <div className="text-xs text-wyd-muted/70 mt-1 line-clamp-2">{ev.description}</div>}
    </div>
  );
};

const ProposalRow = ({ p, onModerate, onReview }) => (
  <div className="glass rounded-xl p-4 flex items-center justify-between gap-4" data-testid={`admin-proposal-row-${p.id}`}>
    <Details p={p} />
    <div className="flex items-center gap-2 shrink-0">
      {p.status === "pending" ? (
        <>
          <IconBtn testid={`approve-${p.id}`} label="Approva"
            onClick={() => (p.source === "public" ? onReview(p) : onModerate(p.id, "approved"))}
            className="bg-green-500/15 text-green-400 hover:bg-green-500/30"><Check size={16} /></IconBtn>
          <IconBtn testid={`reject-${p.id}`} label="Rifiuta" onClick={() => onModerate(p.id, "rejected")} className="bg-red-500/15 text-red-400 hover:bg-red-500/30"><X size={16} /></IconBtn>
        </>
      ) : (
        <span className={`overline ${p.status === "approved" ? "text-green-400" : "text-red-400"}`}>{p.status === "approved" ? "Approvato" : "Rifiutato"}</span>
      )}
    </div>
  </div>
);

export const AdminProposals = ({ proposals, onModerate, onReview }) => {
  const pending = proposals.filter((p) => p.status === "pending");
  const reviewed = proposals.filter((p) => p.status !== "pending");
  return (
    <section data-testid="admin-proposals-section">
      <h2 className="font-display font-bold text-2xl mb-6">Proposte</h2>
      <Group title="Da moderare" count={pending.length} testid="admin-proposals-pending" empty="Nessuna proposta in attesa.">
        {pending.map((p) => <ProposalRow key={p.id} p={p} onModerate={onModerate} onReview={onReview} />)}
      </Group>
      <Group title="Storico" count={reviewed.length} testid="admin-proposals-reviewed" empty="Nessuna proposta già moderata.">
        {reviewed.map((p) => <ProposalRow key={p.id} p={p} onModerate={onModerate} onReview={onReview} />)}
      </Group>
    </section>
  );
};
